/* eslint-disable new-cap */
/* eslint-disable camelcase */
import Phaser from 'phaser';
import BasicSprite from '../BasicSprite';
import { Images, Tweens } from '@abcya/abcya_phaser';
import AudioPlayer from '../../library/AudioPlayer';

export default class PlayerSpaceship_Vertical {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {Phaser.GameObjects.Container} planet 
   * @param {Object} planetTop 
   */
  constructor(scene, planet, planetTop) {
    this.particleDuration = 2;
    this.particlesEnabled = false;

    this.scene = scene;
    this.planet = planet;

    this.posX = 0;
    this.posY_Rocket = -525;
    this.posY_Shadow = -460;

    this.rocketShip = new BasicSprite(this.scene, this.posX, this.posY_Rocket, 'rocket');
    this.rocketShadow = new BasicSprite(this.scene, this.posX, this.posY_Shadow, 'rocketShadow');

    this.scene.add.existing(this.rocketShip);
    this.scene.add.existing(this.rocketShadow);

    this.rocketFlame = new Phaser.GameObjects.Sprite(this.scene, 0, 70, Images.DEFAULT_ATLAS, 'rocketFlame_Vertical');
    this.rocketFlame.setScale(1, 0);
    this.rocketFlame.setOrigin(.5, 0);

    this.scene.add.existing(this.rocketFlame);

    this.planet.add(this.rocketShip);
    this.planet.add(this.rocketShadow);
    this.planet.add(this.rocketFlame);
    this.planet.bringToTop(this.rocketShip);

    // this.rocketCont = this.scene.add.container();
    // this.rocketCont.add(this.rocketShip);
  }

  TakeOff() {
    AudioPlayer.PlaySound(this.scene, AudioPlayer.sounds.ROCKET_BLAST_OFF);

    const particles = this.scene.add.particles(Images.DEFAULT_ATLAS, 'cloud');

    this.emitter = particles.createEmitter(
      {
        x: this.scene.scale.width * 0.5,
        y: this.scene.scale.height * 0.5 + 160,
        alpha: { start: 0.1, end: 0.7, ease: 'Expo.easeOut' },
        scale: { start: 0.4, end: 0.8 },
        frequency: 300,
        lifespan: 900,
        quantity: 2,
        gravityY: 200,
        rotate: { start: 0, end: -50 },
        speed: 80
      }
    );

    this.scene.cameras.main.shake(1000, 0.01);

    this.scene.rocketShip = this.rocketShip;
    this.scene.rocketFlame = this.rocketFlame;

    this.rocketFlame.setOrigin(.5, 0);
    const pos = this.rocketShip.getBottomCenter();
    this.rocketFlame.setPosition(pos.x, pos.y);

    this.scene.time.addEvent({ delay: 600, callback: () => {this.launchShip();} });
  }

  launchShip() {
    this.emitter.stop();
    const distance = Phaser.Math.Difference(this.rocketShip.y, -1200);
    Tweens.addTween(this.rocketFlame, 1000, { scaleY: 1 }, Phaser.Math.Easing.Quadratic.In);
    Tweens.addTween(this.rocketFlame, 3000, { y: this.rocketFlame.y - distance }, Phaser.Math.Easing.Quadratic.In);
    Tweens.addTween(this.rocketShip, 3000, { y: -1200 }, Phaser.Math.Easing.Quadratic.In);
  }

  Update() {
    // if (this.particlesEnabled) {
    //   this.emitter.forEachAlive(this.fadeParticle);
    // }
  }

  fadeParticle(particle) {
    // eslint-disable-next-line no-param-reassign
    particle.alpha = particle.lifespan / 1000;
  }
}


